import { Helmet } from 'react-helmet';
import { Box, Container, Grid, Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';

import plans from '../data/plans';
import ProductCard from '../components/pricing/ProductCard';
import { getIsVisiblePricing } from '../utils';

const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			[theme.breakpoints.up('lg')]: {
				display: 'flex',
				flexDirection: 'column',
				height: '80vh',
				justifyContent: 'center',
			},
		},
	}),
);

function Pricing() {
	const classes = useStyles();
	const paymentStatus = useSelector((_state) => _state.subscription.state);

	return (
		getIsVisiblePricing(paymentStatus) && (
			<Box className={classes.root}>
				<Helmet>
					<title>Pricing | ParcelsApp</title>
				</Helmet>

				<Container maxWidth={false}>
					<Box sx={{ py: 3 }}>
						<Typography align="center" color="textPrimary" gutterBottom variant="h1">
							Flexible shipment tracking plans that grow with your business
						</Typography>
						<Typography align="center" color="textSecondary" variant="body2">
							Start now. I will refund, no questions asked, if you are not happy at any time.
						</Typography>
					</Box>
				</Container>
				<Box sx={{ backgroundColor: 'background.default', py: 3 }}>
					<Container maxWidth={false}>
						<Box sx={{ pt: 2 }}>
							<Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'center' }}>
								{plans.map((product) => (
									<Grid item key={product.id} lg={3} md={6} sm={9} xl={10} xs={12}>
										<ProductCard plan={product} />
									</Grid>
								))}
							</Grid>
						</Box>
					</Container>
				</Box>
			</Box>
		)
	);
}

export default Pricing;
